import styled from 'styled-components';
import { Carousel } from 'react-bootstrap';

export const CarouselContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.md};
`;

export const StyledCarousel = styled(Carousel)`
  direction: rtl;

  .carousel-control-prev,
  .carousel-control-next {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    height: 40px;
    width: 40px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    transition: all 0.3s ease;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(0, 0, 0, 0.8);
    }
  }

  .carousel-control-prev {
    right: -3rem;
    left: auto;
  }

  .carousel-control-next {
    left: -3rem;
    right: auto;
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    transform: rotate(180deg);
    filter: brightness(100);
    width: 1.2rem;
    height: 1.2rem;
  }

  .carousel-indicators {
    position: relative;
    margin-top: 1rem;
    margin-bottom: -1rem;
  }

  .carousel-indicators button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ccc;
    margin: 0 5px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  .carousel-indicators .active {
    background-color: ${({ theme }) => theme.colors.primary};
    transform: scale(1.2);
  }
`;

export const CarouselSlide = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.md};
  padding: ${({ theme }) => theme.spacing.md} 0;
  direction: rtl;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const CardWrapper = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 350px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
